import Carrousel from "../Carrousel/Carrousel"
import { useLocation } from 'react-router-dom'

const captionStyle = {
    fontSize: '2em',
    fontWeight: 'bold',
}
const slideNumberStyle = {
    fontSize: '20px',
    fontWeight: 'bold',
}

const ProjectDetails = () => {
    const location = useLocation()
    const { title, gallery } = location.state

    return (
        <div className="pb-20">
            <h1 className="text-6xl font-bold no-selection text-center mt-4 mb-2">{title}</h1>
            <Carrousel data={gallery} time={2000} width="850px" height="500px" captionStyle={captionStyle} radius="10px" slideNumber={true} slideNumberStyle={slideNumberStyle} captionPosition="bottom" automatic={true} pauseIconColor="white" pauseIconSize="40px" slideBackgroundColor="darkgrey"slideImageFit="cover" thumbnails={true} thumbnailWidth="100px"
                style={{
                    textAlign: "center",
                    maxWidth: "850px",
                    maxHeight: "500px",
                    margin: "40px auto",
                }}
            />
        </div>
    )
}

export default ProjectDetails